var map = {
	"./01-avis.jpg": 47567,
	"./02-thai-smile.jpg": 14115,
	"./03-tip.jpg": 46831,
	"./04-saidaeng-resort.jpg": 61037,
	"./05-tanya.jpg": 11180,
	"./06-kerala-coco-resort.jpg": 58216,
	"./07-tolani-resort.jpg": 13159,
	"./08-the-riverie.jpg": 80596,
	"./09- avani-pattaya.jpg": 38511,
	"./10-prime-town-hotel.jpg": 30603,
	"./11-marrakesh-huahin.jpg": 36226,
	"./12-maven-stylish.jpg": 67752,
	"./13-amatara-welleisure.jpg": 7082,
	"./14-melati-beach.jpg": 58785,
	"./15-chaweng-regent.jpg": 48199,
	"./16-aonang-princeville.jpg": 48267,
	"./17-seaview.jpg": 97348,
	"./18-travizgo.jpg": 87856,
	"./19-cozyresort.jpg": 49719,
	"./20-beach-walk-boutique-resort.jpg": 30767,
	"./21-Areca Lodge.jpg": 28969,
	"./22-ur-the-private.jpg": 11751,
	"./23-the-zeit-riverkwai.jpg": 10577,
	"./24-boutique-raft-resort.jpg": 50328,
	"./25-ananta-burin-resort.jpg": 7823,
	"./26-the-phu-beach-hotel.jpg": 58740,
	"./27-aonang-villa-resort.jpg": 89134,
	"./28-khum-wang-nuea-villa.jpg": 33455,
	"./29-aruntara-riverside-boutique-hotel.jpg": 19993,
	"./30-siripanna-villa.jpg": 53134,
	"./31-beehive-boutique-hotel.jpg": 84953,
	"./32-mission-hills-phuket .jpg": 44065,
	"./33-mii-hotel.jpg": 30274,
	"./34-bamboo-house.jpg": 18609,
	"./35-heritage-chiangrai.jpg": 29990,
	"./36-ur-the-privatee-hua-hiin.jpg": 18449,
	"./37-andakrabi-seatour.jpg": 62709,
	"./38-andakrabi-seatour.jpg": 68913,
	"./39-best-western-patong-beach.jpg": 30336,
	"./40-show-nan.jpg": 53031,
	"./41-suphan.jpg": 31532,
	"./42-chala-number6.jpg": 94569,
	"./43-sabay-hotel.jpg": 58872,
	"./44-sada-resident.jpg": 97252,
	"./45-viang-thapae-resort.jpg": 658,
	"./46-duang-tawan.jpg": 90613,
	"./47-la-flora-khao-lak.jpg": 14404,
	"./48-la-flora-khao-lak.jpg": 51220,
	"./49-my-beach-resort-phuket.jpg": 72463,
	"./50-dewa-phuket-resort-villas.jpg": 50991,
	"./51-sand-dunes-chaolao-beach-resort.jpg": 49769,
	"./bg-promotion-d.jpg": 38266,
	"./promotion-1.jpg": 29196,
	"./promotion-2.jpg": 67158,
	"./promotion-3.jpg": 68858,
	"./promotion-4.jpg": 15790
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17407;